
export function loadDataFun() {
    let loadData = [];
    for (let i = 0; i <= 53; i++) {
        loadData.push({ id: 'home_'+i, src: require('../img/loading/from/Loading_r_' + i + '.png') });
    }
    return loadData;
}

export function loadDataCycleFun() {
    let loadData = [];
    for (let i = 0; i <= 13; i++) {
        loadData.push({ id: 'Loadingxh'+i, src: require('../img/loading/cycle/Loading_xh_' + i + '.png') });
    }
    return loadData;
}

//第一题-第一选项-入场动画
export function page1_1DataFromFun() {
    let loadData = [];
    for (let i = 0; i <= 31; i++) {
        loadData.push({ id: i, src: require('../img/topic/one/1/from/T1A_rc_' + i + '.png') });
    }
    return loadData;
}
//第一题-第一选项-循环动画
export function page1_1DataCycleFun() {
    let loadData = [];
    for (let i = 0; i <= 26; i++) {
        loadData.push({ id: i, src: require('../img/topic/one/1/cycle/T1A_xh_' + i + '.png') });
    }
    return loadData;
}
//第一题-第一选项-出场动画
export function page1_1DataToFun() {
    let loadData = [];
    for (let i = 0; i <= 5; i++) {
        loadData.push({ id: i, src: require('../img/topic/one/1/to/T1A_xs_' + i + '.png') });
    }
    return loadData;
}

//第一题-背景动画
export function page1_1DataBgFun() {
    let loadData = [];
    for (let i = 0; i <= 14; i++) {
        loadData.push({ id: 'bg_'+i, src: require('../img/topic/one/bgform/T1_ty_' + i + '.png') });
    }
    return loadData;
}


//第一题-第二选项-入场动画
export function page1_2DataFromFun() {
    let loadData = [];
    for (let i = 0; i <= 33; i++) {
        loadData.push({ id: i, src: require('../img/topic/one/2/from/T1B_rc_' + i + '.png') });
    }
    return loadData;
}
//第一题-第二选项-循环动画
export function page1_2DataCycleFun() {
    let loadData = [];
    for (let i = 0; i <= 9; i++) {
        loadData.push({ id: i, src: require('../img/topic/one/2/cycle/T1B_xh_' + i + '.png') });
    }
    return loadData;
}
//第一题-第二选项-出场动画
export function page1_2DataToFun() {
    let loadData = [];
    for (let i = 0; i <= 5; i++) {
        loadData.push({ id: i, src: require('../img/topic/one/2/to/T1B_xs_0' + i + '.png') });
    }
    return loadData;
}

//第一题-第三选项-入场动画
export function page1_3DataFromFun() {
    let loadData = [];
    for (let i = 0; i <= 29; i++) {
        loadData.push({ id: i, src: require('../img/topic/one/3/from/T1C_rc_' + i + '.png') });
    }
    return loadData;
}
//第一题-第三选项-循环动画
export function page1_3DataCycleFun() {
    let loadData = [];
    for (let i = 0; i <= 19; i++) {
        loadData.push({ id: i, src: require('../img/topic/one/3/cycle/T1C_xh_' + i + '.png') });
    }
    return loadData;
}
//第一题-第三选项-出场动画
export function page1_3DataToFun() {
    let loadData = [];
    for (let i = 0; i <= 4; i++) {
        loadData.push({ id: i, src: require('../img/topic/one/3/to/T1C_xs_00' + i + '.png') });
    }
    return loadData;
}


//第一题-第四选项-入场动画
export function page1_4DataFromFun() {
    let loadData = [];
    for (let i = 0; i <= 20; i++) {
        loadData.push({ id: i, src: require('../img/topic/one/4/from/T1D_rc-' + i + '.png') });
    }
    return loadData;
}
//第一题-第四选项-循环动画
export function page1_4DataCycleFun() {
    let loadData = [];
    for (let i = 0; i <= 17; i++) {
        loadData.push({ id: i, src: require('../img/topic/one/4/cycle/T1D_xh' + i + '.png') });
    }
    return loadData;
}


//第二题-第一选项-入场动画
export function page2_1DataFromFun() {
    let loadData = [];
    for (let i = 0; i <= 21; i++) {
        loadData.push({ id: i, src: require('../img/topic/two/1/from/T2A_rc_' + i + '.png') });
    }
    return loadData;
}
//第二题-第一选项-循环动画
export function page2_1DataCycleFun() {
    let loadData = [];
    for (let i = 0; i <= 21; i++) {
        loadData.push({ id: i, src: require('../img/topic/two/1/cycle/T1A_xh_' + i + '.png') });
    }
    return loadData;
}
//第二题-第一选项-出场动画
export function page2_1DataToFun() {
    let loadData = [];
    for (let i = 0; i <= 2; i++) {
        loadData.push({ id: i, src: require('../img/topic/two/1/to/T2A_xs_0' + i + '.png') });
    }
    return loadData;
}

//第二题-第二选项-入场动画
export function page2_2DataFromFun() {
    let loadData = [];
    for (let i = 0; i <= 21; i++) {
        loadData.push({ id: i, src: require('../img/topic/two/2/from/T2B_rc_' + i + '.png') });
    }
    return loadData;
}
//第二题-第二选项-循环动画
export function page2_2DataCycleFun() {
    let loadData = [];
    for (let i = 0; i <= 15; i++) {
        loadData.push({ id: i, src: require('../img/topic/two/2/cycle/T2B_xh_' + i + '.png') });
    }
    return loadData;
}
//第二题-第二选项-出场动画
export function page2_2DataToFun() {
    let loadData = [];
    for (let i = 0; i <= 2; i++) {
        loadData.push({ id: i, src: require('../img/topic/two/2/to/T2B_xs_0' + i + '.png') });
    }
    return loadData;
}

//第二题-第三选项-入场动画
export function page2_3DataFromFun() {
    let loadData = [];
    for (let i = 0; i <= 16; i++) {
        loadData.push({ id: i, src: require('../img/topic/two/3/from/T2C_rc_' + i + '.png') });
    }
    return loadData;
}
//第二题-第三选项-循环动画
export function page2_3DataCycleFun() {
    let loadData = [];
    for (let i = 0; i <= 17; i++) {
        loadData.push({ id: i, src: require('../img/topic/two/3/cycle/T2C_rc_' + i + '.png') });
    }
    return loadData;
}
//第二题-第三选项-出场动画
export function page2_3DataToFun() {
    let loadData = [];
    for (let i = 0; i <= 2; i++) {
        loadData.push({ id: i, src: require('../img/topic/two/3/to/T2C_xs_0' + i + '.png') });
    }
    return loadData;
}


//第二题-第四选项-入场动画
export function page2_4DataFromFun() {
    let loadData = [];
    for (let i = 0; i <= 25; i++) {
        loadData.push({ id: i, src: require('../img/topic/two/4/from/T2D_rc_' + i + '.png') });
    }
    return loadData;
}
//第二题-第四选项-循环动画
export function page2_4DataCycleFun() {
    let loadData = [];
    for (let i = 0; i <= 13; i++) {
        loadData.push({ id: i, src: require('../img/topic/two/4/cycle/T2D_xh_' + i + '.png') });
    }
    return loadData;
}


// //第三题-第一选项-入场动画
// export function page3_1DataFromFun() {
//     let loadData = [];
//     for (let i = 0; i <= 17; i++) {
//         loadData.push({ id: i, src: require('../img/topic/san/1/from/T3A_rc_' + i + '.png') });
//     }
//     return loadData;
// }
// //第三题-第一选项-循环动画
// export function page3_1DataCycleFun() {
//     let loadData = [];
//     for (let i = 0; i <= 15; i++) {
//         loadData.push({ id: i, src: require('../img/topic/san/1/cycle/T3A_xh_' + i + '.png') });
//     }
//     return loadData;
// }
// //第三题-第一选项-出场动画
// export function page3_1DataToFun() {
//     let loadData = [];
//     for (let i = 0; i <= 3; i++) {
//         loadData.push({ id: i, src: require('../img/topic/san/1/to/T3A_xs_0' + i + '.png') });
//     }
//     return loadData;
// }


// //第三题-第二选项-入场动画
// export function page3_2DataFromFun() {
//     let loadData = [];
//     for (let i = 0; i <= 14; i++) {
//         loadData.push({ id: i, src: require('../img/topic/san/2/from/T3B_rc_' + i + '.png') });
//     }
//     return loadData;
// }
// //第三题-第二选项-循环动画
// export function page3_2DataCycleFun() {
//     let loadData = [];
//     for (let i = 0; i <= 15; i++) {
//         loadData.push({ id: i, src: require('../img/topic/san/2/cycle/T3A_xh_' + i + '.png') });
//     }
//     return loadData;
// }
// //第三题-第二选项-出场动画
// export function page3_2DataToFun() {
//     let loadData = [];
//     for (let i = 0; i <= 4; i++) {
//         loadData.push({ id: i, src: require('../img/topic/san/2/to/T3B_xs_0' + i + '.png') });
//     }
//     return loadData;
// }



// //第三题-第三选项-入场动画
// export function page3_3DataFromFun() {
//     let loadData = [];
//     for (let i = 0; i <= 31; i++) {
//         loadData.push({ id: i, src: require('../img/topic/san/3/from/T3C_rc_' + i + '.png') });
//     }
//     return loadData;
// }
// //第三题-第三选项-循环动画
// export function page3_3DataCycleFun() {
//     let loadData = [];
//     for (let i = 0; i <= 11; i++) {
//         loadData.push({ id: i, src: require('../img/topic/san/3/cycle/T3C_xh_' + i + '.png') });
//     }
//     return loadData;
// }
// //第三题-第三选项-出场动画
// export function page3_3DataToFun() {
//     let loadData = [];
//     for (let i = 0; i <= 2; i++) {
//         loadData.push({ id: i, src: require('../img/topic/san/3/to/T3C_xs_0' + i + '.png') });
//     }
//     return loadData;
// }



// //第三题-第四选项-入场动画
// export function page3_4DataFromFun() {
//     let loadData = [];
//     for (let i = 0; i <= 23; i++) {
//         loadData.push({ id: i, src: require('../img/topic/san/4/from/T3D_rc_' + i + '.png') });
//     }
//     return loadData;
// }
// //第三题-第四选项-循环动画
// export function page3_4DataCycleFun() {
//     let loadData = [];
//     for (let i = 0; i <= 16; i++) {
//         loadData.push({ id: i, src: require('../img/topic/san/4/cycle/T3D_xh_' + i + '.png') });
//     }
//     return loadData;
// }












//第四题-第一选项-入场动画
export function page3_1DataFromFun() {
    let loadData = [];
    for (let i = 0; i <= 19; i++) {
        loadData.push({ id: i, src: require('../img/topic/si/1/from/T4-A-rc_' + i + '.png') });
    }
    return loadData;
}
//第四题-第一选项-循环动画
export function page3_1DataCycleFun() {
    let loadData = [];
    for (let i = 0; i <= 19; i++) {
        loadData.push({ id: i, src: require('../img/topic/si/1/cycle/T4-A-xh_' + i + '.png') });
    }
    return loadData;
}
//第四题-第一选项-出场动画
export function page3_1DataToFun() {
    let loadData = [];
    for (let i = 0; i <= 4; i++) {
        loadData.push({ id: i, src: require('../img/topic/si/1/to/T4-A-xs_' + i + '.png') });
    }
    return loadData;
}


//第四题-第二选项-入场动画
export function page3_2DataFromFun() {
    let loadData = [];
    for (let i = 0; i <= 19; i++) {
        loadData.push({ id: i, src: require('../img/topic/si/2/from/T4-B-rc_' + i + '.png') });
    }
    return loadData;
}
//第四题-第二选项-循环动画
export function page3_2DataCycleFun() {
    let loadData = [];
    for (let i = 0; i <= 19; i++) {
        loadData.push({ id: i, src: require('../img/topic/si/2/cycle/T4-B-xh_' + i + '.png') });
    }
    return loadData;
}
//第四题-第二选项-出场动画
export function page3_2DataToFun() {
    let loadData = [];
    for (let i = 0; i <= 5; i++) {
        loadData.push({ id: i, src: require('../img/topic/si/2/to/T4-B-xs_' + i + '.png') });
    }
    return loadData;
}



//第四题-第三选项-入场动画
export function page3_3DataFromFun() {
    let loadData = [];
    for (let i = 0; i <= 19; i++) {
        loadData.push({ id: i, src: require('../img/topic/si/3/from/T4-C-rc_' + i + '.png') });
    }
    return loadData;
}
//第四题-第三选项-循环动画
export function page3_3DataCycleFun() {
    let loadData = [];
    for (let i = 0; i <= 19; i++) {
        loadData.push({ id: i, src: require('../img/topic/si/3/cycle/T4-C-xh_' + i + '.png') });
    }
    return loadData;
}
//第四题-第三选项-出场动画
export function page3_3DataToFun() {
    let loadData = [];
    for (let i = 0; i <= 5; i++) {
        loadData.push({ id: i, src: require('../img/topic/si/3/to/T4-C-xs_' + i + '.png') });
    }
    return loadData;
}



//第四题-第四选项-入场动画
export function page3_4DataFromFun() {
    let loadData = [];
    for (let i = 0; i <= 39; i++) {
        loadData.push({ id: i, src: require('../img/topic/si/4/from/T4-D-rc_' + i + '.png') });
    }
    return loadData;
}
//第四题-第四选项-循环动画
export function page3_4DataCycleFun() {
    let loadData = [];
    for (let i = 0; i <= 24; i++) {
        loadData.push({ id: i, src: require('../img/topic/si/4/cycle/T4-D-xs_' + i + '.png') });
    }
    return loadData;
}











//第五题-第一选项-入场动画
export function page4_1DataFromFun() {
    let loadData = [];
    for (let i = 0; i <= 19; i++) {
        loadData.push({ id: i, src: require('../img/topic/wu/1/from/T5-A-rc_' + i + '.png') });
    }
    return loadData;
}
//第五题-第一选项-循环动画
export function page4_1DataCycleFun() {
    let loadData = [];
    for (let i = 0; i <= 19; i++) {
        loadData.push({ id: i, src: require('../img/topic/wu/1/cycle/T5-A-xh_' + i + '.png') });
    }
    return loadData;
}
//第五题-第一选项-出场动画
export function page4_1DataToFun() {
    let loadData = [];
    for (let i = 0; i <= 7; i++) {
        loadData.push({ id: i, src: require('../img/topic/wu/1/to/T5-A-xs_0' + i + '.png') });
    }
    return loadData;
}


//第五题-第二选项-入场动画
export function page4_2DataFromFun() {
    let loadData = [];
    for (let i = 0; i <= 19; i++) {
        loadData.push({ id: i, src: require('../img/topic/wu/2/from/T5-B-rc' + i + '.png') });
    }
    return loadData;
}
//第五题-第二选项-循环动画
export function page4_2DataCycleFun() {
    let loadData = [];
    for (let i = 0; i <= 19; i++) {
        loadData.push({ id: i, src: require('../img/topic/wu/2/cycle/T5-B-xh' + i + '.png') });
    }
    return loadData;
}
//第五题-第二选项-出场动画
export function page4_2DataToFun() {
    let loadData = [];
    for (let i = 0; i <= 4; i++) {
        loadData.push({ id: i, src: require('../img/topic/wu/2/to/T5-B-xs_' + i + '.png') });
    }
    return loadData;
}



//第五题-第三选项-入场动画
export function page4_3DataFromFun() {
    let loadData = [];
    for (let i = 0; i <= 29; i++) {
        loadData.push({ id: i, src: require('../img/topic/wu/3/from/T5-C-rc_' + i + '.png') });
    }
    return loadData;
}
//第五题-第三选项-循环动画
export function page4_3DataCycleFun() {
    let loadData = [];
    for (let i = 0; i <= 19; i++) {
        loadData.push({ id: i, src: require('../img/topic/wu/3/cycle/T5-C-xh' + i + '.png') });
    }
    return loadData;
}
//第五题-第三选项-出场动画
export function page4_3DataToFun() {
    let loadData = [];
    for (let i = 0; i <= 5; i++) {
        loadData.push({ id: i, src: require('../img/topic/wu/3/to/T5-C-xs_' + i + '.png') });
    }
    return loadData;
}



//第五题-第四选项-入场动画
export function page4_4DataFromFun() {
    let loadData = [];
    for (let i = 0; i <= 19; i++) {
        loadData.push({ id: i, src: require('../img/topic/wu/4/from/T5-D-rc_' + i + '.png') });
    }
    return loadData;
}
//第五题-第四选项-循环动画
export function page4_4DataCycleFun() {
    let loadData = [];
    for (let i = 0; i <= 19; i++) {
        loadData.push({ id: i, src: require('../img/topic/wu/4/cycle/T5-D-xh_' + i + '.png') });
    }
    return loadData;
}






//第六题-第一选项-入场动画
export function page5_1DataFromFun() {
    let loadData = [];
    for (let i = 0; i <= 16; i++) {
        loadData.push({ id: i, src: require('../img/topic/liu/1/from/T6-A-rc_' + i + '.png') });
    }
    return loadData;
}
//第六题-第一选项-循环动画
export function page5_1DataCycleFun() {
    let loadData = [];
    for (let i = 0; i <= 9; i++) {
        loadData.push({ id: i, src: require('../img/topic/liu/1/cycle/T6-A-xh_0' + i + '.png') });
    }
    return loadData;
}
//第六题-第一选项-出场动画
export function page5_1DataToFun() {
    let loadData = [];
    for (let i = 0; i <= 7; i++) {
        loadData.push({ id: i, src: require('../img/topic/liu/1/to/T6-A-xs_' + i + '.png') });
    }
    return loadData;
}


//第六题-第二选项-入场动画
export function page5_2DataFromFun() {
    let loadData = [];
    for (let i = 0; i <= 24; i++) {
        loadData.push({ id: i, src: require('../img/topic/liu/2/from/T6-B-' + i + '.png') });
    }
    return loadData;
}
//第六题-第二选项-循环动画
export function page5_2DataCycleFun() {
    let loadData = [];
    for (let i = 0; i <= 24; i++) {
        loadData.push({ id: i, src: require('../img/topic/liu/2/cycle/T6-B-xh_' + i + '.png') });
    }
    return loadData;
}
//第六题-第二选项-出场动画
export function page5_2DataToFun() {
    let loadData = [];
    for (let i = 0; i <= 5; i++) {
        loadData.push({ id: i, src: require('../img/topic/liu/2/to/T6-B-xs_' + i + '.png') });
    }
    return loadData;
}



//第六题-第三选项-入场动画
export function page5_3DataFromFun() {
    let loadData = [];
    for (let i = 0; i <= 19; i++) {
        loadData.push({ id: i, src: require('../img/topic/liu/3/from/T6-C-rc_' + i + '.png') });
    }
    return loadData;
}
//第六题-第三选项-循环动画
export function page5_3DataCycleFun() {
    let loadData = [];
    for (let i = 0; i <= 19; i++) {
        loadData.push({ id: i, src: require('../img/topic/liu/3/cycle/T6-C-xh_' + i + '.png') });
    }
    return loadData;
}
//第六题-第三选项-出场动画
export function page5_3DataToFun() {
    let loadData = [];
    for (let i = 0; i <= 5; i++) {
        loadData.push({ id: i, src: require('../img/topic/liu/3/to/T6-C-xs_' + i + '.png') });
    }
    return loadData;
}



//第六题-第四选项-入场动画
export function page5_4DataFromFun() {
    let loadData = [];
    for (let i = 0; i <= 24; i++) {
        loadData.push({ id: i, src: require('../img/topic/liu/4/from/T6-D-rc_' + i + '.png') });
    }
    return loadData;
}
//第六题-第四选项-循环动画
export function page5_4DataCycleFun() {
    let loadData = [];
    for (let i = 0; i <= 19; i++) {
        loadData.push({ id: i, src: require('../img/topic/liu/4/cycle/T6-D-xh_' + i + '.png') });
    }
    return loadData;
}













//按钮-出场动画
export function btnFrom() {
    let loadData = [];
    for (let i = 0; i <= 13; i++) {
        loadData.push({ id: 'btn_'+i, src: require('../img/topic/btnform/AN_rc_' + i + '.png') });
    }
    return loadData;
}
//按钮-循环动画
// export function btnCycle() {
//     let loadData = [];
//     for (let i = 0; i <= 11; i++) {
//         loadData.push({ id: i, src: require('../img/topic/btnto/AN_xh_' + i + '.png') });
//     }
//     return loadData;
// }